function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5D0202",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#5D0202",
  stopOpacity: 0.498
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "url(#a)",
  fillRule: "evenodd",
  opacity: 0.06
}, /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 438,
  r: 146,
  transform: "matrix(1 0 0 -1 0 876)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 146,
  r: 146,
  transform: "matrix(-1 0 0 1 292 0)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 438,
  cy: 438,
  r: 146,
  transform: "matrix(0 1 1 0 0 0)"
}));

function SvgBgPatternThreeCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 584,
    height: 584,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternThreeCircles);
export default __webpack_public_path__ + "static/media/bg-pattern-three-circles.53a3ac81.svg";
export { ForwardRef as ReactComponent };